import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { teamUserFragment } from "core/queries/GetTeam";
import {
  ManageUser as ManageUserGenerated,
  ManageUserVariables as ManageUserVariablesGenerated,
  ManageUser_manageUser_user as UserDataGenerated,
} from "core/queries/__generated__/ManageUser";

export interface ManageUserResponse extends ManageUserGenerated {}
export interface ManageUserVariables extends ManageUserVariablesGenerated {}
export interface UserData extends UserDataGenerated {}

export const manageUser = gql`
  mutation ManageUser(
    $userId: ID!
    $firstName: String
    $lastName: String
    $cityId: ID
    $addRoles: [DispatchRoleName!]
    $removeRoles: [DispatchRoleName!]
    $addTags: [ID!]
    $removeTags: [ID!]
  ) {
    manageUser(
      id: $userId
      firstName: $firstName
      lastName: $lastName
      cityId: $cityId
      addRoles: $addRoles
      removeRoles: $removeRoles
      addTags: $addTags
      removeTags: $removeTags
    ) {
      user {
        id
        ...TeamUser
      }
    }
  }
  ${teamUserFragment}
`;

interface UseManageUserMutationOptions {
  awaitRefetchQueries?: boolean;
  refetchQueries?: string[];
  variables: ManageUserVariables;
}

export const useManageUser = ({
  awaitRefetchQueries = false,
  refetchQueries = [],
  variables,
}: UseManageUserMutationOptions) =>
  useMutation<ManageUserResponse, ManageUserVariables>(manageUser, {
    awaitRefetchQueries,
    refetchQueries,
    variables,
  });
